// extracted by mini-css-extract-plugin
module.exports = {"cuePink":"#ee7975"};